<template>
  <v-container
    fluid
  >
    <h2>{{ book.title}}</h2>
    <p>{{ book.author }}</p>

    <QuoteItem v-for="quote in quotes" :key="quote.id" :quote="quote"/>

  </v-container>
</template>

<script>
import QuoteItem from '../components/QuoteItem.vue'

export default {
  name: 'Book',
  components: {
    QuoteItem
  },
  data () {
    return {
    }
  },
  mounted () {
    this.$emit('updatenav', -1)
  },
  computed: {
    book () {
      const bid = this.$route.params.id
      const b = this.$store.getters.getBookById(bid)
      if (b === undefined) {
        if (bid[0] === '@') {
          const newId = this.$store.getters.getBookIdByOldId(bid)
          if (newId !== undefined) {
            this.$router.replace({ name: 'book', params: { id: newId } })
            return this.$store.getters.getBookById(newId)
          }
        }
      }
      return b
    },
    quotes () {
      return this.$store.getters.getQuotesByBook(this.book.id)
    }
  },
  methods: {

  }
}
</script>
